export default {"src":"/_next/static/image/public/images/ic_phone_green.dd39b0046e8706462e52aa8b9678a9f2.svg","height":28,"width":28};